/**
 * Check if a user is a Celerity employee based on their email domain
 * @param email - User's email address
 * @returns true if user is a Celerity employee, false otherwise
 */
export const isCelerityEmployee = (email?: string): boolean => {
  if (!email) {
    return false
  }

  return (
    email.endsWith('@celerityenterprises.com') ||
    email.endsWith('@celerityenterprises.io')
  )
}
